<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">


      <form class="login100-form validate-form">
        <div class="Frame11"
          style="flex-direction: column; justify-content: center; align-items: center; display: inline-flex">
          <div class="logo"
            style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
            <div class="Frame7"
              style="align-self: stretch; justify-content: center; align-items: flex-start; gap: 5.89px; display: inline-flex">
              <div class="Frame14"
                style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                <div class="Frame54"
                  style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 16px; display: inline-flex">
                  <div class="Frame13"
                    style="justify-content: flex-start; align-items: center; gap: 5.89px; display: flex">
                    <div class="Frame6"
                      style="padding: 11.79px; border-radius: 47.16px; border: 2.21px #05477B solid; justify-content: flex-start; align-items: flex-start; gap: 5.89px; display: flex">
                      <img style="width: 30.95px; height: 30.95px; position: relative"
                        src="../../../assets/images/luggage.png" />
                    </div>
                  </div>
                  <div class="Tourist"
                    style="color: #05477B; font-size: 56px; font-family: Roboto; font-weight: 300; line-height: 67.20px; word-wrap: break-word">
                    Tourist </div>
                </div>
                <div class="Frame4"
                  style="align-self: stretch; padding-left: 80px; justify-content: flex-start; align-items: flex-start; gap: 5.89px; display: inline-flex">
                  <div class="SimplifyYourTouristTaxToday"
                    style="color: #424242; font-size: 11.05px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 19.16px; letter-spacing: 0.34px; word-wrap: break-word">
                    Simplify Your Tourist Tax </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row"
            style="align-self: stretch; justify-content: left; align-items: center; display: inline-flex; margin-bottom:16px">
            <mat-icon iconPositionEnd (click)="backToLogin()"
              style="cursor: pointer;">arrow_back</mat-icon>&nbsp;RECOVER YOUR PASSWORD
          </div>

          <div class="FillInWithTheCodeSentToYourEmailAddress"
            style="width: 100%; color: #424242; font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 28px; letter-spacing: 0.15px; word-wrap: break-word">
            Fill in with the code sent to your email address</div>
          <div class="Frame53"
            style="align-self: stretch; flex-direction: column; justify-content: center; align-items: center; gap: 32px; display: flex; ">
            <div class="from-body">
              <div class="form-elements">
                <div class="row code-container">
                  <code-input [isCodeHidden]="false" #inputElement [isFocusingOnLastByClickIfFilled]="false"
                    [codeLength]="4" [autofocus]="true" [(ngModel)]="this.code" (codeChanged)="onCodeChanged($event)"
                    (codeCompleted)="onCodeCompleted($event)">
                  </code-input>
                </div>

              </div>
              <br />
              <div>
                <button (click)="validateCode()" [disabled]="!isCodeValid"
                  [ngClass]="{'button-stepper-allow': isCodeValid ,'button-stepper': !isCodeValid  }"
                  mat-raised-button>CONFIRM CODE
                  <mat-icon [svgIcon]="icons.ArrowRightIcon" iconPositionEnd />
                </button>
              </div>
              <br />
              <div>
                <button class="go-back" (click)="resendCode()" type="button" mat-button>RESEND CODE<mat-icon
                    [svgIcon]="icons.ArrowRightIcon" iconPositionEnd /></button>
              </div>
            </div>
          </div>

        </div>
      </form>

      <div class="login100-more" style="background-image: url('../.././../assets/images/loginImage2.jpeg');">
      </div>
    </div>
  </div>
</div>